(function () {
  if (window.__mcCartPop) return;
  window.__mcCartPop = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pop,
    bodyEl,
    headingEl,
    recsCacheId = null,
    busy = false;

  function el() {
    if (!pop) {
      pop = document.querySelector('[data-mc-cartpop]');
      if (pop) {
        bodyEl = pop.querySelector('[data-mc-cartpop-body]');
        headingEl = pop.querySelector('[data-mc-cartpop-heading]');
      }
    }
    return pop;
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    return (
      '$' +
      (cents / 100)
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
  }
  function sizedImg(src, px) {
    if (!src) return '';
    if (/_(\d+)x(\d+)?\./.test(src)) return src;
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + px + 'x$1$2');
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function extractAddedQty(body) {
    try {
      if (!body) return null;
      if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j.items && j.items.length)
          return j.items.reduce(function (n, i) {
            return n + (parseInt(i.quantity, 10) || 1);
          }, 0);
        return parseInt(j.quantity, 10) || 1;
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var qs = body.getAll ? body.getAll('quantity') : [];
        if (qs.length > 1)
          return qs.reduce(function (n, q) {
            return n + (parseInt(q, 10) || 1);
          }, 0);
        var q = body.get ? body.get('quantity') : null;
        return parseInt(q, 10) || 1;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return parseInt(body.get('quantity'), 10) || 1;
      }
    } catch (e) {}
    return null;
  }
  function addedLines(data) {
    if (!data) return [];
    var arr = data.items && data.items.length ? data.items : [data];
    return arr
      .filter(function (x) {
        return x && (x.product_title || x.title);
      })
      .map(function (it) {
        var props = it.properties || {};
        return {
          title: it.product_title || it.title,
          variant: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
          image:
            it.image || it.featured_image || (it.featured_image && it.featured_image.url) || '',
          qty: it.quantity || 1,
          url: it.url || '#',
          product_id: it.product_id || it.id,
          kind: props._mc_native_bundle_kind || '',
          addonLabel: props._mc_native_addon_label || '',
        };
      });
  }

  function discountSummary(cart) {
    var rows = {},
      order = [];
    function add(title, amt) {
      amt = parseInt(amt, 10) || 0;
      if (!amt) return;
      title = title || 'Discount';
      if (rows[title] == null) {
        rows[title] = 0;
        order.push(title);
      }
      rows[title] += amt;
    }
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        add(a.discount_application && a.discount_application.title, a.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      add(a.title, a.total_allocated_amount);
    });
    return {
      total: parseInt(cart.total_discount, 10) || 0,
      rows: order.map(function (t) {
        return { title: t, amount: rows[t] };
      }),
    };
  }

  function injectAddSavings(cart) {
    if (!cart || !(parseInt(cart.total_discount, 10) > 0)) return;
    var actions = pop.querySelector('.mc-cartpop__actions');
    if (!actions || pop.querySelector('.mc-cartpop__saved-note')) return;
    var ds = discountSummary(cart);
    var titles = ds.rows
      .map(function (d) {
        return d.title;
      })
      .join(', ');
    var note = document.createElement('div');
    note.className = 'mc-cartpop__saved-note';
    note.innerHTML =
      '<span class="mc-cartpop__saved-dot" aria-hidden="true"></span><span>' +
      esc(titles || 'Discount applied') +
      ' &middot; you save ' +
      money(ds.total) +
      '</span>';
    actions.parentNode.insertBefore(note, actions);
  }
  function renderAdd(lines, addedQty) {
    var addons = lines.filter(function (l) {
      return l.kind === 'addon';
    });
    var mains = lines.filter(function (l) {
      return l.kind !== 'addon';
    });
    var displayLines = mains.length ? mains : lines;
    var count = addedQty || lines.length;
    headingEl.textContent = count + (count === 1 ? ' item' : ' items') + ' added to your cart';
    var showQty =
      displayLines.length === 1 && !addons.length && addedQty && addedQty > 1 ? addedQty : null;
    var addonsHtml = addons.length
      ? '<ul class="mc-cartpop__addons">' +
        addons
          .map(function (a) {
            return '<li class="mc-cartpop__addon">+ ' + esc(a.addonLabel || a.title) + '</li>';
          })
          .join('') +
        '</ul>'
      : '';
    var itemsHtml = displayLines
      .map(function (l, i) {
        var img = sizedImg(l.image, 160);
        return (
          '' +
          '<div class="mc-cartpop__item mc-cartpop__item--plain">' +
          '<a class="mc-cartpop__thumb" href="' +
          esc(l.url) +
          '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="mc-cartpop__info">' +
          '<a class="mc-cartpop__name" href="' +
          esc(l.url) +
          '">' +
          esc(l.title) +
          (showQty ? ' <span class="mc-cartpop__q">×' + showQty + '</span>' : '') +
          '</a>' +
          (l.variant ? '<span class="mc-cartpop__vt">' + esc(l.variant) + '</span>' : '') +
          (i === displayLines.length - 1 ? addonsHtml : '') +
          '</div>' +
          '</div>'
        );
      })
      .join('');
    bodyEl.innerHTML =
      '<div class="mc-cartpop__items">' +
      itemsHtml +
      '</div>' +
      '<div class="mc-cartpop__actions">' +
      '<a class="mc-cartpop__btn" href="' +
      (pop.getAttribute('data-cart-url') || root + 'cart') +
      '">View cart &amp; checkout</a>' +
      '<button type="button" class="mc-cartpop__btn mc-cartpop__btn--outline" data-mc-cartpop-close>Continue shopping</button>' +
      '</div>';
  }
  function loadRecs(productId) {
    var recsEl = pop.querySelector('[data-mc-cartpop-recs]');
    var trackEl = pop.querySelector('[data-mc-cartpop-recs-track]');
    if (!recsEl || !productId) {
      if (recsEl) recsEl.hidden = true;
      return;
    }
    fetch(
      root + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related',
      { headers: { 'Accept': 'application/json' } },
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var ps = (data && data.products) || [];
        if (!ps.length) {
          recsEl.hidden = true;
          return;
        }
        recsCacheId = productId;
        trackEl.innerHTML = ps
          .map(function (p) {
            var img = sizedImg(p.featured_image || (p.images && p.images[0]) || '', 360);
            var onSale = p.compare_at_price && p.compare_at_price > p.price;
            var priceHtml = onSale
              ? '<span class="mc-cartpop__rec-sale">Sale</span><span class="mc-cartpop__rec-price"><span class="is--sale">' +
                money(p.price) +
                '</span> <s>' +
                money(p.compare_at_price) +
                '</s></span>'
              : '<span class="mc-cartpop__rec-price">' + money(p.price) + '</span>';
            return (
              '<a class="mc-cartpop__rec" href="' +
              esc(p.url) +
              '">' +
              '<div class="mc-cartpop__rec-media">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
              '</div>' +
              '<div class="mc-cartpop__rec-title">' +
              esc(p.title) +
              '</div>' +
              priceHtml +
              '</a>'
            );
          })
          .join('');
        recsEl.hidden = false;
      })
      .catch(function () {
        recsEl.hidden = true;
      });
  }

  function bundleOf(it) {
    return (it.properties && it.properties._mc_native_bundle_id) || '';
  }
  function kindOf(it) {
    return (it.properties && it.properties._mc_native_bundle_kind) || '';
  }

  function orderBundles(items) {
    var byId = {};
    items.forEach(function (it) {
      var k = bundleOf(it);
      if (k) {
        (byId[k] = byId[k] || []).push(it);
      }
    });
    var out = [],
      seen = {};
    items.forEach(function (it) {
      var k = bundleOf(it);
      if (!k) {
        out.push(it);
        return;
      }
      if (seen[k]) return;
      seen[k] = true;
      var grp = byId[k];
      var parents = grp.filter(function (x) {
        return kindOf(x) !== 'addon';
      });
      var addons = grp.filter(function (x) {
        return kindOf(x) === 'addon';
      });
      out = out.concat(parents, addons);
    });
    return out;
  }
  function renderCart(cart) {
    var items = cart.items || [];
    pop.classList.toggle('is--empty', items.length === 0);
    if (!items.length) {
      headingEl.textContent = 'Your cart';
      var shopUrl = pop.getAttribute('data-shop-url') || root + 'collections/all';
      bodyEl.innerHTML =
        '<div class="mc-cartpop__empty">' +
        '<p class="mc-cartpop__empty-text">Your cart is empty.</p>' +
        '<a class="mc-cartpop__btn mc-cartpop__btn--outline" href="' +
        esc(shopUrl) +
        '">Start shopping</a>' +
        '</div>';
      return;
    }
    headingEl.textContent = 'Your cart (' + cart.item_count + ')';

    items = orderBundles(items);

    items = items
      .filter(function (it) {
        return it.product_type !== 'warranty_item';
      })
      .concat(
        items.filter(function (it) {
          return it.product_type === 'warranty_item';
        }),
      );
    var itemsHtml = items
      .slice()
      .map(function (it) {
        var img = sizedImg(it.image, 160);
        var variant =
          it.variant_title && it.variant_title !== 'Default Title'
            ? '<span class="mc-cartpop__vt">' + esc(it.variant_title) + '</span>'
            : '';

        var bundleId = (it.properties && it.properties._mc_native_bundle_id) || '';
        var bundleKind = (it.properties && it.properties._mc_native_bundle_kind) || '';
        var isAddon = bundleKind === 'addon';

        var isWarranty = it.product_type === 'warranty_item';
        var isLocked = isAddon || isWarranty;
        var lockTag = isWarranty ? 'Protection' : 'Add-on';
        var qtyBlock = isLocked
          ? '<span class="mc-cartpop__qty-locked">Qty ' +
            it.quantity +
            '</span><span class="mc-cartpop__addon-tag">' +
            lockTag +
            '</span>'
          : '<div class="mc-cartpop__qty">' +
            '<button type="button" class="mc-cartpop__qtybtn" data-mc-qty="-1" aria-label="Decrease">&minus;</button>' +
            '<span class="mc-cartpop__qtyval">' +
            it.quantity +
            '</span>' +
            '<button type="button" class="mc-cartpop__qtybtn" data-mc-qty="1" aria-label="Increase">+</button>' +
            '</div>';

        var thumbHtml = img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '';
        var thumb = isLocked
          ? '<span class="mc-cartpop__thumb is--nolink">' + thumbHtml + '</span>'
          : '<a class="mc-cartpop__thumb" href="' + esc(it.url) + '">' + thumbHtml + '</a>';

        var displayName = isWarranty
          ? window.__mcWarrantyLabel || 'Protect your purchase'
          : it.product_title;
        var nameHtml = isLocked
          ? '<span class="mc-cartpop__name mc-cartpop__name--nolink">' +
            esc(displayName) +
            '</span>'
          : '<a class="mc-cartpop__name" href="' + esc(it.url) + '">' + esc(displayName) + '</a>';
        return (
          '' +
          '<div class="mc-cartpop__item' +
          (isLocked ? ' is--addon' : '') +
          (isWarranty ? ' is--warranty' : '') +
          '" data-key="' +
          esc(it.key) +
          '"' +
          (bundleId
            ? ' data-bundle-id="' + esc(bundleId) + '" data-bundle-kind="' + esc(bundleKind) + '"'
            : '') +
          '>' +
          thumb +
          '<div class="mc-cartpop__info">' +
          nameHtml +
          variant +
          '<div class="mc-cartpop__row">' +
          qtyBlock +
          '<span class="mc-cartpop__price">' +
          (it.original_line_price > it.final_line_price
            ? '<span class="is--disc">' +
              money(it.final_line_price) +
              '</span> <s class="mc-cartpop__price-was">' +
              money(it.original_line_price) +
              '</s>'
            : money(it.final_line_price)) +
          '</span>' +
          '</div>' +
          '<button type="button" class="mc-cartpop__remove" data-mc-remove>Remove</button>' +
          '</div>' +
          '</div>'
        );
      })
      .join('');
    var ds = discountSummary(cart);
    var footTop = '';
    if (ds.total > 0) {
      footTop +=
        '<div class="mc-cartpop__subrow"><span>Subtotal</span><span>' +
        money(cart.original_total_price) +
        '</span></div>';
      footTop += ds.rows
        .map(function (d) {
          return (
            '<div class="mc-cartpop__discount"><span>' +
            esc(d.title) +
            '</span><span>&minus;' +
            money(d.amount) +
            '</span></div>'
          );
        })
        .join('');
      footTop +=
        '<div class="mc-cartpop__subtotal mc-cartpop__subtotal--total"><span>Total</span><span>' +
        money(cart.total_price) +
        '</span></div>';
    } else {
      footTop +=
        '<div class="mc-cartpop__subtotal"><span>Subtotal</span><span>' +
        money(cart.total_price) +
        '</span></div>';
    }
    bodyEl.innerHTML =
      '<div class="mc-cartpop__items mc-cartpop__items--cart">' +
      itemsHtml +
      '</div>' +
      '<div class="mc-cartpop__foot">' +
      footTop +
      '<a class="mc-cartpop__btn" href="' +
      (pop.getAttribute('data-cart-url') || root + 'cart') +
      '">View cart &amp; checkout</a>' +
      '</div>';
  }
  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    pop.classList.add('is--busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        setCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
        pop.classList.remove('is--busy');
      });
  }

  function changeBundle(item, qty) {
    var bid = item.getAttribute('data-bundle-id');
    if (!bid) {
      changeLine(item.getAttribute('data-key'), qty);
      return;
    }
    var sel = '[data-bundle-id="' + (window.CSS && CSS.escape ? CSS.escape(bid) : bid) + '"]';
    var nodes = pop.querySelectorAll(sel);
    if (nodes.length < 2) {
      changeLine(item.getAttribute('data-key'), qty);
      return;
    }
    var updates = {};
    nodes.forEach(function (node) {
      var k = node.getAttribute('data-key');
      if (k) updates[k] = qty;
    });
    if (busy) return;
    busy = true;
    pop.classList.add('is--busy');
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        setCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
        pop.classList.remove('is--busy');
      });
  }

  var COUNT_SEL =
    '.t4s-icon-cart__wrap .t4s-count-box, .t4s-site-nav__cart .t4s-count-box, [data-cart-count] .t4s-count-box';
  var lastCount = null;
  function applyCount(box) {
    if (lastCount == null) return;
    var want = lastCount > 0 ? String(lastCount) : '';
    if (box.textContent !== want) box.textContent = want;
    var wantOp = lastCount > 0 ? '1' : '0';
    if (box.style.opacity !== wantOp || box.style.getPropertyPriority('opacity') !== 'important') {
      box.style.setProperty('opacity', wantOp, 'important');
    }
  }
  function setCartCount(n) {
    lastCount = n;
    document.querySelectorAll(COUNT_SEL).forEach(applyCount);
  }

  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      if (lastCount != null) document.querySelectorAll(COUNT_SEL).forEach(applyCount);
    });
    ['.t4s-site-nav__icons', '.t4s-header', 'header'].forEach(function (s) {
      var elx = document.querySelector(s);
      if (elx)
        mo.observe(elx, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'style'],
        });
    });
  }

  function initCartCount() {
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        setCartCount(c.item_count);
      })
      .catch(function () {});
  }
  if (document.readyState !== 'loading') initCartCount();
  else document.addEventListener('DOMContentLoaded', initCartCount);
  function chatFade(on) {
    var c = document.querySelector('shopify-chat') || document.getElementById('shopify-chat');
    if (!c) return;
    c.style.transition = 'opacity .2s ease';
    c.style.opacity = on ? '0' : '';
    c.style.pointerEvents = on ? 'none' : '';
  }
  function open(mode, sticky) {
    if (!el()) return;
    pop.classList.toggle('mc-cartpop--add', mode === 'add');
    pop.classList.toggle('mc-cartpop--cart', mode === 'cart');
    pop.classList.toggle('mc-cartpop--sticky', !!sticky);
    pop.hidden = false;
    document.documentElement.classList.add('mc-cartpop-open');
    void pop.offsetWidth;
    pop.classList.add('is--open');
    chatFade(true);
  }
  function close() {
    if (!pop) return;
    pop.classList.remove('is--open');
    document.documentElement.classList.remove('mc-cartpop-open');
    chatFade(false);
    setTimeout(function () {
      if (pop && !pop.classList.contains('is--open')) pop.hidden = true;
    }, 340);
  }

  function openAfterAdd(data, addedQty) {
    if (!el()) return;

    if (window.__mcSuppressAddPopdown) return;

    var nonWarranty =
      data && data.items
        ? data.items.filter(function (i) {
            return i.product_type !== 'warranty_item';
          })
        : null;
    if (nonWarranty && nonWarranty.length === 0) return;
    var sticky = !!window.__mcStickyAdd;
    window.__mcStickyAdd = false;
    renderAdd(addedLines(data), addedQty);
    open('add', sticky);
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        setCartCount(c.item_count);
        injectAddSavings(c);
      })
      .catch(function () {});
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(closeDrawer, 40);
    setTimeout(closeDrawer, 260);
  }
  function openCart() {
    if (!el()) return;
    fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        setCartCount(cart.item_count);
        open('cart', false);
      })
      .catch(function () {
        window.location.href = root + 'cart';
      });
  }

  function closeDrawer() {
    var d = document.getElementById('t4s-mini_cart');
    if (!d) return;
    if (d.getAttribute('aria-hidden') === 'false' || !d.classList.contains('t4s-dn')) {
      var cbtn = d.querySelector('[data-drawer-close]');
      if (cbtn) cbtn.click();
      d.setAttribute('aria-hidden', 'true');
      d.classList.add('t4s-dn');
    }
  }

  function isAddUrl(u) {
    return typeof u === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(u);
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var p = _fetch.apply(this, arguments);
      if (isAddUrl(url) && String(method).toUpperCase() === 'POST') {
        var aq = extractAddedQty(init && init.body);
        p.then(function (res) {
          if (!res || !res.ok) return;
          res
            .clone()
            .json()
            .then(function (data) {
              setTimeout(function () {
                openAfterAdd(data, aq);
              }, 60);
            })
            .catch(function () {
              setTimeout(function () {
                openAfterAdd(null, aq);
              }, 60);
            });
        }).catch(function () {});
      }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open,
    _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mcIsAdd = String(method).toUpperCase() === 'POST' && isAddUrl(url);
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__mcIsAdd) {
      var aq = extractAddedQty(body);
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        var data = null;
        try {
          data = JSON.parse(this.responseText);
        } catch (e) {}
        setTimeout(function () {
          openAfterAdd(data, aq);
        }, 60);
      });
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    if (!pop || pop.hidden) return;
    var item = e.target.closest('.mc-cartpop__item[data-key]');
    if (item && pop.contains(item)) {
      var key = item.getAttribute('data-key');
      var isParent = item.getAttribute('data-bundle-kind') === 'parent';
      if (e.target.closest('[data-mc-remove]')) {
        if (isParent) {
          changeBundle(item, 0);
        } else {
          changeLine(key, 0);
        }
        return;
      }
      var q = e.target.closest('[data-mc-qty]');
      if (q) {
        var cur = parseInt(item.querySelector('.mc-cartpop__qtyval').textContent, 10) || 1;
        var next = Math.max(0, cur + parseInt(q.getAttribute('data-mc-qty'), 10));
        if (isParent) {
          changeBundle(item, next);
        } else {
          changeLine(key, next);
        }
        return;
      }
    }
    if (e.target.closest('[data-mc-cartpop-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (!e.target.closest('.mc-cartpop__panel')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function neutralizeNativeCart() {
    if (window.MCNativeCart && window.MCNativeCart.open && !window.MCNativeCart.__mcNoop) {
      window.MCNativeCart.open = function () {
        return Promise.resolve();
      };
      window.MCNativeCart.__mcNoop = true;
    }
  }
  neutralizeNativeCart();
  setTimeout(neutralizeNativeCart, 400);
  setTimeout(neutralizeNativeCart, 1200);
  document.addEventListener('DOMContentLoaded', neutralizeNativeCart);

  var drawerEl = document.getElementById('t4s-mini_cart');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(closeDrawer).observe(drawerEl, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class'],
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var icon = e.target.closest(
        '[data-drawer-options*="mini_cart"], .t4s-site-nav__cart a, .t4s-icon-cart__wrap, .t4s-icon-cart__wrap a',
      );
      if (!icon) return;

      if (e.target.closest('.mc-cartpop')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openCart();
    },
    true,
  );
})();
